<template>
  <div class="pagination-component">
    <ul v-show="totalPages > 1" class="pagination">
      <li :class="'page-item ' + disabledPageClass(page - 1)">
        <a class="page-link" href="javascript:void(0)" @click="prev">&lt;</a>
      </li>

      <li :class="'page-item ' + allowedPageClass(pageNum) +activeClass(pageNum)" v-for="pageNum in totalPages">
        <a class="page-link" href="javascript:void(0)" @click="setPage(pageNum)">{{ pageNum }}</a>
      </li>

      <li :class="'page-item ' + disabledPageClass(page + 1)">
        <a class="page-link" href="javascript:void(0)" @click="next">&gt;</a>
      </li>
    </ul>

    <p v-show="parseInt(items)">{{count}}</p>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    countText: {
      type: String,
      default: 'Showing {from} to {to} of {count} results|{count} results|1 result'
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  model: {
    prop: 'currentPage',
    event: 'page-change'
  },
  data: function() {
    return { page: this.currentPage }
  },
  watch: {
    currentPage: function(val) {
      this.page = val
    }
  },
  computed: {
    totalPages: function() {
      return this.items ? Math.ceil(this.items / this.perPage) : 1
    },
    count: function() {
      let from = (this.currentPage - 1) * this.perPage + 1
      let to = this.currentPage == this.totalPages ? this.items : from + this.perPage - 1
      let parts = this.countText.split('|')
      let i = this.items == 1 ? 2 : this.totalPages == 1 ? 1 : 0
      return parts[i].replace('{count}', this.items).replace('{from}', from).replace('{to}', to)
    }
  },
  methods: {
    setPage: function(page) {
      if (this.allowedPage(page)) {
        this.page = page
        this.$emit('page-set', page)
       
      }
    },
    next: function() {
      return this.setPage(this.page + 1)
    },
    prev: function() {
      return this.setPage(this.page - 1)
    },
    allowedPage: function(page) {
      let length=10;
      let min=1;
      let total=this.totalPages;
      if (length > total) length = total;

      let start = this.page - 5;
      start = Math.max(start, min);
      start = Math.min(start, min + total - length);
      
      return page >= start && page <= start+9
    },
    allowedPageClass: function(page) {
      
      return this.allowedPage(page) ? '' : 'hiddenPage'
    },
    disabledPageClass: function(page) {
       return (page >= 1 && page <= this.totalPages) ? '' : 'disabled' 
    },
    activeClass: function(page) {
      return this.page == page ? 'active' : ''
    }
  }
}
</script>

<style scoped>
  .pagination-component {
    text-align: left;
    font-size: 11px;
    margin-top:0px;
  }

  .hiddenPage{
    display:none
  }

  .pagination{
    margin:0px;
  }

 
  .page-link {
    color: grey;
    font-weight: bold;
    font-size: smaller;
    box-shadow: none;
  }

  .page-item.active .page-link{
    background: #EE861D;
    color: white;
    border-color: white;
  }

</style>



// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/Pagination.vue